import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ManagersSection } from "../components/managers-section";
import { ClubInfoCard } from "../components/club-info-card";
import { ClubDetailsSection } from "../components/club-details-section";

export function ClubInfoPage() {
  return (
    <>
      {/* Header */}
      <header className="border-b border-gray-200 bg-white px-6 py-4">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900">Paramètres</h1>
        </div>

        {/* Tabs */}
        <Tabs defaultValue="club-info" className="mt-4">
          <TabsList>
            <TabsTrigger value="club-info">Informations du club</TabsTrigger>
            <TabsTrigger value="tarifs" disabled>
              Gestion des tarifs
            </TabsTrigger>
          </TabsList>

          <TabsContent value="club-info" className="mt-0">
            {/* Content rendered in main below */}
          </TabsContent>
          <TabsContent value="tarifs">
            <div className="py-8 text-center text-gray-500">
              Bientôt disponible
            </div>
          </TabsContent>
        </Tabs>
      </header>

      {/* Main content */}
      <main className="flex-1 overflow-y-auto bg-gray-50 p-6">
        <div className="mx-auto max-w-6xl space-y-8">
          {/* Managers section */}
          <ManagersSection />

          {/* Organization section */}
          <section>
            <h2 className="mb-4 text-lg font-semibold text-gray-900">
              Organisation du club
            </h2>

            <div className="flex gap-6">
              {/* Club info card - fixed width */}
              <div className="w-64 shrink-0">
                <ClubInfoCard />
              </div>

              {/* Club details - flexible width */}
              <div className="flex-1">
                <ClubDetailsSection />
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}
